import { useSelector } from 'react-redux';
import type { ReactElement } from 'react';
import { AppState } from '../store';
import { ErrorMessage } from '../components/ErrorMessage';
import { EApiType } from '../data/Constants';

/**
 * Custom hook to handle API-specific error display
 * @param apiType - The API type to check for errors
 * @returns JSX element with error message if error matches the API type, null otherwise
 */
export const useApiError = (apiType: EApiType): ReactElement | null => {
  const error = useSelector((state: AppState) => state.error);

  if (error.code && error.type === apiType) {
    return (
      <h4>
        <ErrorMessage error={error} />
      </h4>
    );
  }

  return null;
};
